/** Origins that may send WA_EMBEDDED_SIGNUP postMessage */
export const FACEBOOK_MESSAGE_ORIGINS = [
  "https://www.facebook.com",
  "https://web.facebook.com",
  "https://business.facebook.com",
];

export function defaultEmbeddedSignupExtras() {
  return {
    version: "v4",
    sessionInfoVersion: "3",
    featureType: "whatsapp_business_app_onboarding",
    setup: {
      business: {
        id: null,
        name: null,
        email: null,
        phone: { code: null, number: null },
        website: null,
        address: {
          streetAddress1: null,
          streetAddress2: null,
          city: null,
          state: null,
          zipPostal: null,
          country: null,
        },
        timezone: null,
      },
      phone: { displayName: null, category: null, description: null },
      preVerifiedPhone: { ids: null },
      solutionID: null,
      whatsAppBusinessAccount: { ids: null },
    },
  };
}

export const COEXISTENCE_EVENT = "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING";

/**
 * Parse postMessage payload from Embedded Signup (session info).
 * @returns {{ wabaId?: string, phoneNumberId?: string, businessId?: string, isCoexistence?: boolean } | null}
 */
export function parseEmbeddedSignupMessage(eventData) {
  let parsed = eventData;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return null;
    }
  }
  if (!parsed || parsed.type !== "WA_EMBEDDED_SIGNUP") {
    return null;
  }

  const inner =
    parsed.data && typeof parsed.data === "object" ? parsed.data : parsed;

  return {
    wabaId: pickId(inner, [
      "waba_id",
      "wabaId",
      "whatsapp_business_account_id",
      "wabaID",
    ]),
    phoneNumberId: pickId(inner, [
      "phone_number_id",
      "phoneNumberId",
      "phone_number_ID",
    ]),
    businessId: pickId(inner, ["business_id", "businessId", "businessID"]),
    isCoexistence: parsed.event === COEXISTENCE_EVENT,
  };
}

function pickId(obj, keys) {
  for (const k of keys) {
    const v = obj[k];
    if (v != null && String(v).trim()) {
      return String(v).trim();
    }
  }
  return undefined;
}
